import Headline from 'components/library/Headline';
import { mqLargeMax } from 'styled/tools/media-queries';
import styled from 'styled-components';

const StyledHeadline = styled.div`
  margin-bottom: 13px;
  @media (${mqLargeMax}) {
    margin-bottom: 36.14px;
  }
`;

export type VideoProps = {
  title: string;
  posterTime: number;
  thumb: string;
  review?: string;
  name?: string;
  memberFrom?: string;
  ref?: any;
  playbackId?: string;
  devPlaybackId?: string;
  mobilePlaybackId?: string;
  mobileDevPlaybackId?: string;
};

export const videos: VideoProps[] = [
  {
    playbackId: 'oB02r9BUIqkJHUxbfyWLh00yK5GO6GqRQReiSskS5SRL4',
    devPlaybackId: 'RAGGejzNXK7LZh02xMZbCPf9DeehqjfNtP5Tw4xtPQlk',
    mobilePlaybackId: 'jPg401yfLuKkhTNqFtcMEUCdeidqj25YN00WG2upHt9rE',
    mobileDevPlaybackId: 'u01fdMziZlEL8901FVvkOs4YOi5LUXUsVFuOiJ02IaQN00A',
    posterTime: 3,
    thumb:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1752675690/library/reviews/thumbnail_zam.png',
    title: 'Zam',
  },
  {
    playbackId: 'iM00sNT9JitDRoL3sKGoI7wWXDmYwx7eAw5ialhbLBOk',
    devPlaybackId: 'yAFu27L00T01EGdDrf5SzYMnMCWGfnDQUngJr9tHzSZfc',
    mobilePlaybackId: 'EuX7bFlojLBm7cxPs2IKMBew1I7J0102vo74KVGwW016wc',
    mobileDevPlaybackId: '7S02mL4so7YmGpysiAwmB7GBZ9zKMvf01aBuGDC2kkUMw',
    posterTime: 2.5,
    thumb:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1752675841/library/reviews/alice_thumbnail.png',
    title: 'Alice',
  },
];

export const ReviewCarouselHeadline = () => {
  return (
    <StyledHeadline>
      <Headline
        title='Over 1 million health transformations (and counting).'
        body='See how real people are changing their health with Seed.'
        variant='center'
        wrapperType='div'
        contentMaxInlineSize='450px'
        titleMaxInlineSize='700px'
      />
    </StyledHeadline>
  );
};
